import React from "react";

export default class Comment extends React.Component {

    render() {
        return(
            <div className="comment-container">
                <h3>Leave a reply</h3>
                <div>
                    <label>Comment *</label>
                    <textarea id="comment-textarea" maxLength='2000' required />
                </div>
                <div>
                    <div>
                        <label>Name *</label>
                        <input type='text' required />
                    </div>
                    <div>
                        <label>Email *</label>
                        <input type='text' required />
                    </div>
                </div>
                <button type="submit">Post Comment</button>
            </div>
        )
    }
}